import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '@/context/AuthContext';
import { hasManagementRole } from './types';

interface AdminGuardProps {
    children: ReactNode;
}

const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
    const { isLoading, isAuthenticated, role } = useAuth();
    const navigate = useNavigate();

    const hasAccess = hasManagementRole(role);

    useEffect(() => {
        if (!isLoading && isAuthenticated && !hasAccess) {
            navigate('/', { replace: true });
        }
    }, [isLoading, isAuthenticated, hasAccess, navigate]);

    if (isLoading || !hasAccess) {
        return null;
    }

    return <>{children}</>;
};

export default AdminGuard;
